import { render } from "./UnsolvedTickets.vue?vue&type=template&id=7bb22881&ts=true"
import script from "./UnsolvedTickets.vue?vue&type=script&lang=ts"
export * from "./UnsolvedTickets.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__